// We use milliseconds because it's what Meetup uses for some stupid reason
const HOUR = 1000 * 60 * 60;
export const GUESSTIMATED_EVENT_LENGTH_MS = 2 * HOUR;
